import Sidebar from "../components/Sidebar";
import { Outlet } from "react-router-dom";

export default function DashboardLayout() {
  return (
    <div className="dashboard">
      <Sidebar />
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}